import React from 'react';
import { useQuery } from '@apollo/client';
import { observer } from 'mobx-react';
import Client from '../../client/Client';
import { useStore } from '../../store/storeUtils';
import Loader from './../common/Loader';
const CMSSelectPreviewConfiguration = observer(props => {
  const store = useStore();
  const setPreviewConfiguration = configuration => {
    console.log('conf', configuration);
    store.setRenderPreviewConfiguration(configuration);
    store.synchronizeWholeConfiguration();
  };
  if (!props.localDevelopment) {
    setPreviewConfiguration({
      configuration: props.defaultConfiguration
    });
    return '';
  }
  const {
    loading,
    error,
    data
  } = useQuery(Client.GET_ALL_PREVIEW_CONFIGURATIONS, Client.GET_ALL_PREVIEW_CONFIGURATIONS_OPTIONS(store.projectId, 'Emotions', store.previewConfigurations.length > 0));
  if (loading) return /*#__PURE__*/React.createElement(Loader, {
    whiteLoader: true,
    affectSave: false
  });
  if (error) return /*#__PURE__*/React.createElement("div", null, "An error has occured");
  if (store.previewConfigurations.length > 0) {
    setPreviewConfiguration(store.previewConfigurations[0]);
  }
  console.log('data', data);
  if (data && data.getAllPreviewConfigurations && data.getAllPreviewConfigurations.length > 0) {
    const configurations = data.getAllPreviewConfigurations;

    //store.setPreviewConfigurations(configurations);

    if (configurations.length === 0) {
      setPreviewConfiguration({
        configuration: props.defaultConfiguration
      });
    } else {
      // Select last config
      setPreviewConfiguration(configurations[configurations.length - 1]);
    }
  }
  return '';

  /*return (
        <>
            {
                store.previewConfigurations.length === 0 ? (
                    <div>Non ci sono configurazioni temporanee.</div>
                ) : toJS(store.previewConfigurations).map((configuration) => {
                    return (
                        <div>
                            Preview configuration {configuration.tool}
                              {
                                store.previewConfiguration && store.previewConfiguration.id === configuration.id ? (
                                    <div>Selezionata</div>
                                ) : (
                                    <Button onClick={() => { setPreviewConfiguration(configuration) }}>Seleziona</Button>
                                )
                            }
                        </div>
                    )
                })
            }
        </>
    );*/
});

export default CMSSelectPreviewConfiguration;